<div class="certificate-input">
  <div class="input">
    <div class="header">
      @if (name) {
        <span [class.bold]="bold">{{name}}</span>
      }
      @if (canDownload) {
        <button type="button" class="btn btn-link" [appCopyValue]="control.value">
          <span class="copied-hide">Copy Certificate</span>
          <span class="copied-show">Copied</span>
        </button>
      }
    </div>
    <label>
      <textarea [formControl]="control" [placeholder]="placeholder" class="form-control">
      </textarea>
      @if (uploadError) {
        <div class="input-error">
          <span>Failed to upload file</span>
        </div>
      }
    </label>
  </div>
  <div class="action-buttons">
    @if (control.enabled) {
      <label [for]="name + '-file-upload'" class="file-upload btn btn-secondary btn-wide">
        <img alt="" class="inset-icon" src="assets/default/files.svg">
        Upload from File
        <input [id]="name + '-file-upload'" (input)="onCertInput($event)" accept=".pem" type="file" hidden>
      </label>
    }
    @if (canDownload) {
      <button type="button" class="btn btn-secondary btn-wide" (click)="download.emit()">Download Certificate</button>
    }
  </div>
</div>
